import React from "react";

import {
  formatMoney,
  formatRatio,
} from "../../../utils/formatters";

export default function ScenarioSummaryCard({
  scenario,
  baseline,
  settings,
}) {
  const currency = settings?.currency || "USD";

  if (!scenario) return null;

  return (
    <div className="bg-white rounded-xl border border-slate-200 p-4">
      <div className="flex items-start justify-between gap-4">
        <div>
          <h3 className="text-base font-semibold text-slate-900">
            {scenario.name}
          </h3>

          <p className="text-sm text-slate-500 mt-1">
            {scenario.asset_name || "No asset assigned"}
          </p>
        </div>

        <span className="rounded-full bg-slate-100 px-3 py-1 text-xs font-medium text-slate-700">
          {scenario.incident_type || "Digital Risk"}
        </span>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mt-5">
        <Metric
          label="Expected Annual Loss"
          value={formatMoney(
            baseline?.expected_annual_loss,
            currency
          )}
        />

        <Metric
          label="Loss Event Frequency"
          value={formatRatio(
            baseline?.lef,
            2
          )}
        />

        <Metric
          label="P90"
          value={formatMoney(
            baseline?.p90,
            currency
          )}
        />

        <Metric
          label="P95"
          value={formatMoney(
            baseline?.p95,
            currency
          )}
        />

        <Metric
          label="P99"
          value={formatMoney(
            baseline?.p99,
            currency
          )}
        />
      </div>
    </div>
  );
}

function Metric({
  label,
  value,
}) {
  return (
    <div>
      <p className="text-xs font-medium text-slate-500">
        {label}
      </p>

      <p className="text-lg font-semibold text-slate-900 mt-1">
        {value}
      </p>
    </div>
  );
}